<div class="p-4">
  <h1 mat-dialog-title class="w-full !text-primary !typo-lg-bold">
    {{ data.title }}
  </h1>
  <p mat-dialog-content>
    {{ data.message }}
  </p>
  <div class="mt-12 flex flex-row" mat-dialog-actions>
    <button
      mat-button
      (click)="close(false)"
    >
      {{ 'GENERICS.CANCEL' | translate }}
    </button>
    <button
      mat-button
      (click)="close(true)"
      class="text-primary typo-base-bold bg-accent-gradient"
    >
      {{ 'GENERICS.CONFIRM' | translate }}
    </button>
  </div>
</div>
